<template>
	<div>
		<PrivateOrderMonitoring :type="user.owner_type || 'supplier'" />
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
import PrivateOrderMonitoring from '@/components/private-orders/index.vue';

export default {
	name: 'SellerPrivateOrder',
	components: {
		PrivateOrderMonitoring,
	},
	computed: {
		...mapGetters({
			user: 'user',
			isOwner: 'isOwner',
			isAdmin: 'isAdmin',
			isHasFeature: 'isHasFeature',
			isDropshipper: 'isDropshipper',
			isUserCan: 'isUserCan',
		}),
		isPrivateOrderVisible() {
			const visible = this.isUserCanAccess;
			return visible;
		},
		isUserCanAccess() {
			const feature = 'private_order';
			let isCanAccess = false;
			if (this.isOwner || this.isAdmin) {
				isCanAccess = this.isHasFeature(feature);
			} else {
				isCanAccess = this.isUserCan('wholesale_view_order');
			}

			return isCanAccess;
		},
	},
	mounted() {
		if (!this.isPrivateOrderVisible) {
			this.$router.push({ name: 'home' });
		}
	},
};
</script>
